import RemitoVentaAPI from '@/api/venta/remitoVenta';

export default {
  namespaced: true,
  actions: {
    fetch_remito_venta(_, params) {
      return RemitoVentaAPI.index(params);
    },
    get_remito_venta(_, id) {
      return RemitoVentaAPI.show(id);
    },
    create_remito_venta(_, data) {
      return RemitoVentaAPI.create(data);
    },
    update_remito_venta(_, { id, data }) {
      return RemitoVentaAPI.update(id, data);
    },
    destroy_remito_venta(_, id) {
      return RemitoVentaAPI.destroy(id);
    },
    cambiar_estado_remito_venta(_, { id, estado }) {
      return RemitoVentaAPI.cambiarEstado(id, estado);
    },
    generar_factura_remito(_, id) {
      return RemitoVentaAPI.generarFactura(id);
    },
  },
};
